import timelineData from './timeline.json';
import { SiteLanguage } from '../i18n/language';

export interface TimelineItem {
  dateKey: string;
  titleKey: string;
  contentKey: string;
  link?: string;
  note?: string;
  imgimg?: string;
  img?: string;
  imgByLang?: { en: string; zh: string };
  imgBySiteLanguage?: Partial<Record<SiteLanguage, string>>;
  video?: string;
}

export const timeline: TimelineItem[] = timelineData;

export default timeline;
